import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardActionArea from '@material-ui/core/CardActionArea'
import CardContent from '@material-ui/core/CardContent'
import ProgressiveThumbnail from './ProgressiveThumbnail'
import { Box } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

const styles = theme => ({
  card: {
    // width: '11.5rem',
    // height: '8.75rem',
    width: '100%',
    height: '100%',
    borderRadius: 0,
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
    backgroundColor: theme.modeColors.cardBackground
  },
  cardBorder: {
    // width: '11.25rem',
    // height: '8.5rem',
    border: '2px solid #f46b1e',
    boxShadow: 'none'
  },
  actionArea: {
    marginLeft: '-10px',
    marginRight: '-10px',
    width: 'calc(100% + 20px)',
    '&:hover $focusHighlight': {
      opacity: 1
    }
  },
  focusHighlight: {
    backgroundColor: 'rgba(247, 248, 249, 0.6)',
    aspectRatio: '1.414/1'
  },
  classStyle: {
    position: 'absolute',
    top: 0,
    left: '10px',
    fontSize: '0.75rem',
    fontWeight: 700,
    textTransform: 'uppercase',
    padding: '0.25rem 0.75rem 0.125rem',
    color: '#fff',
    backgroundColor: '#ffa632',
    zIndex: 2
  },
  truncate: {
    width: '100px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginBottom: 0,
    fontWeight: 500
  }
})

const MdProposal = ({
  classes,
  seen,
  proposal,
  proposalClass,
  reactAppUrl
}) => {
  const { t } = useTranslation('proposals')
  return (
    <Card className={classNames(classes.card, { [classes.cardBorder]: !seen })}>
      <CardActionArea
        classes={{
          root: classes.actionArea,
          focusHighlight: classes.focusHighlight
        }}
      >
        <ProgressiveThumbnail
          src={reactAppUrl + proposal.thumbnail_url}
          objectFit="contain"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }}
        />
        <CardContent className="py-1 px-2">
          <div className="d-flex justify-content-between align-items-center">
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              width="100%"
            >
              <div>
                <h3 className="mb-0 mr-3">{proposal.number}</h3>
              </div>
              <Box textAlign="right">
                <h5 className={classes.truncate}>{proposal.name}</h5>
              </Box>
            </Box>
            <div
              className="sm"
              style={{
                position: 'absolute',
                top: proposalClass ? '21px' : 0,
                left: '10px',
                padding: seen ? 0 : '5px 10px',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                color: '#fff'
              }}
            >
              {seen ? '' : t('Unseen')}
            </div>
            {proposalClass && (
              <div
                className={classes.classStyle}
                style={{ backgroundColor: proposalClass.colour }}
              >
                {proposalClass.class}
              </div>
            )}
          </div>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}

MdProposal.propTypes = {
  classes: PropTypes.object.isRequired,
  reactAppUrl: PropTypes.string.isRequired
}

const mapStateToProps = state => {
  return {
    reactAppUrl: state.proposals.envValues.reactAppUrl
  }
}

export default connect(mapStateToProps)(withStyles(styles)(MdProposal))
